import styled from 'styled-components'

const ContenedorContacto = styled.div`
    padding: 10px 0;
    border-bottom: 1px solid rgba(0,0,0,.2);
    border-top: 1px solid rgba(0,0,0,.2);
`;
 
const Nombre = styled.p`
    font-weight: bold;
`;
 
const Correo = styled.p`
    font-style: italic;
    color: #6B6B6B;
    margin: 5px 0;
`;
 
const Boton = styled.button`
    padding: 5px 20px;
    border: none;
    cursor: pointer;
    border-radius: 3px;
    margin: 0px 2px;
    margin-bottom: 10px;
    transition: .3s ease all;
    outline: none;
    background: #C4C4C4;
    color: #fff;
    font-size: 12px;
 
    &:hover {
        background: #3D76E9;
    }
`;

const Parrafos = styled.div`
    padding: 0 10px;
    font-size: 13px;
    background: white;
    border: 2px solid rgba(0,0,0,.2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 15px 0;
`

const ContenidoFormulario = styled.div`
    width: 100%;
    margin-top: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #6b5b95;
`

const Formulario = styled.form`
    width: 100%;
    padding: 8px;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
`

const Input = styled.input`
    width: 100%;
    padding: 10px;
    height: 70px;
    border: 2px solid rgba(0,0,0,.2);
    border-radius: 3px;
    transition: .2s ease all;
    outline: none;
    &:focus {
        border: 2px solid #3D76E9;
    }
`;

const BotonBorrar = styled.button`
    font-size: 10px;
    margin: 10px;
    margin-right: 10px;
    background: #4040a1;
    color: white;
    border: none;
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
        background: #a2a8d3;
    }
`

const Boton2 = styled.button`   
    margin-top: 15px;
    padding: 10px 30px;
    border: none;
    cursor: pointer;
    border-radius: 3px;
    transition: .3s ease all;
    outline: none;
    background: #4040a1;
    color: #fff;
    font-size: 12px;
    &:hover {
        background: #a2a8d3;
    }
`;

const ContenidoPrincipal = styled.div`
    margin-top: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color:  #6b5b95;
`
 
 
export {Boton2, Formulario, ContenidoPrincipal, ContenidoFormulario, BotonBorrar, Boton, Parrafos, Input, Correo, Nombre, ContenedorContacto}